import React from "react";
import { useHistory } from "react-router-dom";
import {
	OrganizationSectionContainer,
	OrganizationLeftSide,
	OrganizationImage,
	OrganizationDescription,
	OrganizationButton,
	OrganizationDescriptionName,
	OrganizationDescriptionNumContainer,
} from "./style";
import ic_Group from "@/assets/ic_Group.svg";
import organiImage from "@/assets/organiImage.svg";
// import { getCompanyInfo } from "@/redux/organization/selector";
// import { useSelector } from "react-redux";
import Loader from "@/components/Loader";
import { CompanyResponseDto } from "@/api/interface";
import { useTranslation } from "react-i18next";

interface OrganizationSectionProps {
	companyInfo: CompanyResponseDto | null;
}

const OrganizationSection = ({ companyInfo }: OrganizationSectionProps) => {
	const { t } = useTranslation();
	const history = useHistory();
	if (!companyInfo) {
		return <Loader />;
	}
	return (
		<OrganizationSectionContainer>
			<OrganizationLeftSide>
				<OrganizationImage>
					<img src={organiImage} alt="사진없음" />
				</OrganizationImage>

				<OrganizationDescription>
					<OrganizationDescriptionName>
						{companyInfo.name}
					</OrganizationDescriptionName>
					<OrganizationDescriptionNumContainer>
						<span style={{ marginRight: "5px" }}>
							{companyInfo.userCount} Member
						</span>
						<div
							style={{
								display: "inline-block",
								height: "5px",
								width: "5px",
								borderRadius: "50%",
								backgroundColor: "#858585",
							}}
						/>
						<span style={{ marginLeft: "5px" }}>
							{companyInfo.appCount} application
						</span>
					</OrganizationDescriptionNumContainer>
				</OrganizationDescription>
			</OrganizationLeftSide>

			<OrganizationButton
				variant="outlined"
				endIcon={<img src={ic_Group} alt="사진없음" />}
				onClick={() => {
					history.push(`/organization/general`);
				}}
			>
				{t("home.organization_management")}
			</OrganizationButton>
		</OrganizationSectionContainer>
	);
};

export default OrganizationSection;
